<template>
  <RevCard
    class="mood-inverse bg-surface-default-low grid grid-cols-[auto_1fr] gap-x-12 p-16"
    :class="
      isLong
        ? 'md:grid-cols-[auto_minmax(0,1fr)_auto] md:gap-x-0 md:px-32 md:py-24'
        : 'md:max-w-[480px] md:gap-x-16 md:p-24'
    "
    data-test="guest-account-activation-card"
  >
    <div
      class="bg-static-info-max mood-main col-start-1 row-start-1 flex size-40 shrink-0 items-center justify-center rounded-full"
      :class="{ 'md:row-span-2 md:self-center': isLong }"
    >
      <IconAvatar aria-hidden="true" size="24" />
    </div>

    <h2
      class="text-static-default-hi heading-2 col-start-2 row-start-1 min-w-0 self-center"
      :class="{ 'md:ml-16 md:self-end': isLong }"
    >
      {{ title }}
    </h2>

    <p
      class="text-static-default-hi body-1 col-span-2 row-start-2 mt-8 min-w-0 text-left md:col-start-2 md:col-span-1"
      :class="isLong ? 'md:ml-16 md:mt-0 md:self-start' : 'md:mt-4'"
    >
      {{ description }}
    </p>

    <RevButton
      class="col-span-2 row-start-3 mt-16 w-full md:col-span-1 md:w-auto"
      :class="
        isLong
          ? 'md:col-start-3 md:row-span-2 md:row-start-1 md:ml-24 md:mt-0 md:min-w-[315px] md:self-center'
          : 'md:col-start-2 md:justify-self-start'
      "
      data-test="guest-account-activation-cta"
      :to
      variant="primary"
    >
      {{ i18n(translations.action) }}
    </RevButton>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { IconAvatar } from '@ds/icons/IconAvatar'
import type { Location } from '@ds/types/Location'

import translations from './GuestAccountActivationCard.translations'

const props = withDefaults(
  defineProps<{
    /** Card title. */
    title: string
    /** Card description. */
    description: string
    /** Destination of the account activation CTA. */
    to: Location
    /**
     * Layout variant.
     * Both variants share the mobile layout.
     * - default: CTA below the description on desktop
     * - long: vertically stacked title/description beside the icon and CTA on desktop
     */
    variant?: 'default' | 'long'
  }>(),
  { variant: 'default' },
)

const i18n = useI18n()
const isLong = computed(() => props.variant === 'long')
</script>
